import { Component } from '@angular/core';
import { AuthService, AuthWebService, TokenService } from './shared/services';
import { environment as env } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { WebTypeConstant } from './shared/constants/common-constant';
import { LanguageService } from './shared/services/language/language.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    language: any = null;
    domain: string = '';
    webType: string | null = '';

    constructor(
        private token: TokenService,
        protected translate: TranslateService,
        private authWebService: AuthWebService,
        private authService: AuthService,
    ) {
        this.setLanguage();
    }

    private setLanguage(): void {
        const savedLanguage = this.token.getLocalToken(env.TokenKeys.Language);
        if (savedLanguage) {
            this.language = savedLanguage;
            this.translate.setDefaultLang(this.language);
        } else {
            this.token.setLocalToken(env.TokenKeys.Language, env.DefaultLanguageCode);
            this.language = this.translate.getBrowserCultureLang();
            this.translate.setDefaultLang(this.language || env.DefaultLanguageCode);
        }
    }

    async ngOnInit() {
        await this.authWebService.getAuthWeb();

        this.authService.getWebType().subscribe(webType => {
            this.webType = webType;
        });
    }
}
